import React from 'react'
import Header from '../../components/header'
import BookMeeting from '../../components/booking'
import Contact from '../../components/contact'
import Subscribtion from '../../components/subscribtion'
import Footer from '../../components/footer'
import { graphql, Link } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import {
  faChevronRight,
  faArrowAltCircleLeft,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import logo from '../../images/logo.png'
import styles from './styles.module.scss'
import footerStyles from '../../components/footer/styles.module.scss'

export const query = graphql`
  query($slug: String!) {
    contentfulBusinessConsultancy(slug: { eq: $slug }) {
      title
      slug
      image {
        file {
          url
        }
        description
      }
      description {
        json
      }
    }
    contentfulContact {
      title
      description {
        json
      }
    }
    contentfulBookMeeting {
      title
      description {
        json
      }
    }
    allContentfulFooter {
      edges {
        node {
          id
          title
          image {
            file {
              url
            }
          }
          url
        }
      }
    }
    contentfulFooterAddress {
      title
      copyright
      buildingNumber
      streetName
      postalCode
      zipCode
      country
    }
  }
`

const BusinessConsultancy = props => {
  const allFooter = props.data.allContentfulFooter.edges.map(({ node }) => (
    <Footer
      key={node.id}
      url={node.url}
      img={node.image.file.url}
      alt={node.title}
    />
  ))
  const options = {
    renderNode: {
      'embedded-asset-block': node => {
        const alt = node.data.target.fields.title['en-US']
        const url = node.data.target.fields.file['en-US'].url
        return <img alt={alt} src={url} className={styles.image} />
      },
    },
  }
  const previousConsultancy = props.pageContext.previous
    ? {
        url: `/consultancy/${props.pageContext.previous.slug}`,
        title: props.pageContext.previous.title,
      }
    : null

  const nextConsultancy = props.pageContext.next
    ? {
        url: `/consultancy/${props.pageContext.next.slug}`,
        title: props.pageContext.next.title,
      }
    : null
  return (
    <div>
      <Header />
      <div className={styles.container}>
        <div className={styles.containerHeader}>
          <div className={styles.prevNext}>
            <div>
              {previousConsultancy && (
                <Link to={previousConsultancy.url}>
                  <FontAwesomeIcon icon={faChevronLeft} />
                  <span className={styles.prevText}>Previous</span>
                </Link>
              )}
            </div>
            <div>
              {nextConsultancy && (
                <Link to={nextConsultancy.url}>
                  <span className={styles.nextText}>Next</span>
                  <FontAwesomeIcon icon={faChevronRight} />
                </Link>
              )}
            </div>
          </div>
          <h2 className={styles.title}>
            {props.data.contentfulBusinessConsultancy.title}
          </h2>
        </div>
        <div className={styles.containerBody}>
          {documentToReactComponents(
            props.data.contentfulBusinessConsultancy.description.json,
            options,
          )}
        </div>

        <div className={styles.prevNext}>
          <div>
            {previousConsultancy && (
              <Link to={previousConsultancy.url}>
                <FontAwesomeIcon icon={faChevronLeft} />
                <span className={styles.prevText}>Previous</span>
              </Link>
            )}
          </div>
          <div>
            {nextConsultancy && (
              <Link to={nextConsultancy.url}>
                <span className={styles.nextText}>Next</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </Link>
            )}
          </div>
        </div>
        <div className={styles.prevNext}>
          <div>
            {previousConsultancy && (
              <div>
                <Link to={previousConsultancy.url}>
                  {props.pageContext.index}. {previousConsultancy.title}{' '}
                </Link>
              </div>
            )}
          </div>
          <div>
            {nextConsultancy && (
              <div>
                <Link to={nextConsultancy.url}>
                  {props.pageContext.index + 2}. {nextConsultancy.title}{' '}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <BookMeeting
        title={props.data.contentfulBookMeeting.title}
        content={documentToReactComponents(
          props.data.contentfulBookMeeting.description.json,
        )}
      />
      <Contact
        title={props.data.contentfulContact.title}
        content={documentToReactComponents(
          props.data.contentfulContact.description.json,
        )}
      />
      <div className={footerStyles.mainfooter}>
        <footer className={footerStyles.footerdiv}>
          <div className={footerStyles.footertext}>
            <h3>{props.data.contentfulFooterAddress.title}</h3>
            <div>
              <div>{props.data.contentfulFooterAddress.buildingNumber}</div>
              <div>{props.data.contentfulFooterAddress.streetName}</div>
              <div>{props.data.contentfulFooterAddress.postalCode}</div>
              <div>{props.data.contentfulFooterAddress.zipCode}</div>
              <div>{props.data.contentfulFooterAddress.country}</div>
            </div>
          </div>
          <div className={footerStyles.subscribe}>
            <Subscribtion />
          </div>
          <div className={footerStyles.footericon}>{allFooter}</div>
        </footer>
        <div className={footerStyles.dateDiv}>
          <div className={footerStyles.footerText}>
            {props.data.contentfulFooterAddress.copyright}{' '}
            {new Date().getFullYear()}
          </div>
          <div className={footerStyles.developedBy}>
            <a href="https://www.integrify.io/en/" target="blank">
              <p>Developed By Integrify</p>
              <img
                src={logo}
                alt="integrify logo"
                className={footerStyles.logo}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BusinessConsultancy
